/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ShopifyOrderDtoBase
 * auto generated base class for the model ShopifyOrderDtoModel.
 */
export const ShopifyOrderDtoModelBase = ModelBase
  .named('ShopifyOrderDto')
  .props({
    __typename: types.optional(types.literal("ShopifyOrderDto"), "ShopifyOrderDto"),
    id: types.union(types.undefined, types.string),
    name: types.union(types.undefined, types.string),
    orderNumber: types.union(types.undefined, types.null, types.integer),
    createdAt: types.union(types.undefined, types.string),
    customerName: types.union(types.undefined, types.null, types.string),
    email: types.union(types.undefined, types.null, types.string),
    phone: types.union(types.undefined, types.null, types.string),
    shippingAddress: types.union(types.undefined, types.null, types.string),
    deliveryMethod: types.union(types.undefined, types.null, types.string),
    deliveryInstructions: types.union(types.undefined, types.null, types.string),
    deliveryPhone: types.union(types.undefined, types.null, types.string),
    paymentStatus: types.union(types.undefined, types.string),
    fulfillmentStatus: types.union(types.undefined, types.string),
    tags: types.union(types.undefined, types.array(types.string)),
    note: types.union(types.undefined, types.null, types.string),
    noteAttributes: types.union(types.undefined, types.array(types.string)),
    totalWeight: types.union(types.undefined, types.null, types.number),
    isSynced: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ShopifyOrderDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get name() { return this.__attr(`name`) }
  get orderNumber() { return this.__attr(`orderNumber`) }
  get createdAt() { return this.__attr(`createdAt`) }
  get customerName() { return this.__attr(`customerName`) }
  get email() { return this.__attr(`email`) }
  get phone() { return this.__attr(`phone`) }
  get shippingAddress() { return this.__attr(`shippingAddress`) }
  get deliveryMethod() { return this.__attr(`deliveryMethod`) }
  get deliveryInstructions() { return this.__attr(`deliveryInstructions`) }
  get deliveryPhone() { return this.__attr(`deliveryPhone`) }
  get paymentStatus() { return this.__attr(`paymentStatus`) }
  get fulfillmentStatus() { return this.__attr(`fulfillmentStatus`) }
  get tags() { return this.__attr(`tags`) }
  get note() { return this.__attr(`note`) }
  get noteAttributes() { return this.__attr(`noteAttributes`) }
  get totalWeight() { return this.__attr(`totalWeight`) }
  get isSynced() { return this.__attr(`isSynced`) }
}
export function selectFromShopifyOrderDto() {
  return new ShopifyOrderDtoModelSelector()
}

export const shopifyOrderDtoModelPrimitives = selectFromShopifyOrderDto().name.orderNumber.createdAt.customerName.email.phone.shippingAddress.deliveryMethod.deliveryInstructions.deliveryPhone.paymentStatus.fulfillmentStatus.tags.note.noteAttributes.totalWeight.isSynced
